// Setup › Webhooks at `/c/{slug}/setup/webhooks` (M1-07; core, managers): features/webhooks.
import { createRoute } from "@tanstack/react-router";
import { useCompany } from "../features/use-feature";
import { WebhooksScreen } from "../features/webhooks/webhooks-screen";
import { setupRoute } from "./c.$slug.setup";

export const setupWebhooksRoute = createRoute({
  getParentRoute: () => setupRoute,
  path: "webhooks",
  component: function Webhooks() {
    const { api } = setupWebhooksRoute.useRouteContext();
    return <WebhooksScreen api={api} company={useCompany()} />;
  },
});
